import { apiRequest } from '../utils/useAPIRequest';
import constant from '../utils/constant';
import { adminStore } from '../stores';
import { UseRequest } from '../utils/useAPIRequest';
import { capitalizeFirstLetter } from '../utils/utils';

const getAdminUsers = async (query = "") => {
  const { status, errorMessage, data } = await apiRequest({
    url: `/admin?${query}`,
    method: 'get'
  });
  if (status === constant.Success) {
    adminStore.setAdmins(data);
    return { status }
  }
  return { status, errorMessage };
};

const createAdminUsers = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: '/admin',
    method: 'post',
    payload: payload
  });
  if (status === constant.Success) {
    await getAdminUsers()
    return { status };
  }
  return { status, errorMessage };
};

const getPermissions = async () => {
  try {
    let { data } = await UseRequest({
      url: '/permissions?type=ADMIN',
      method: 'get',
    });
    data = data.map(perm => {
      perm.permissions = perm.permissions.map(value => {
        value.name = capitalizeFirstLetter(value.name);
        return value;
      });
      return perm;
    });
    adminStore.setPermissions(data);
    return { status: constant.Success };
  } catch (error) {
    const { data } = error.response || {};
    return { status: constant.Failed, errorMessage: data.message };
  }
};

const editAdminUsers = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: '/users/admin/user',
    method: 'patch',
    payload: payload
  });

  if (status === constant.Success) {
    await getAdminUsers()
    return { status };
  }
  return { status, errorMessage };
};

const setAdminPermissions = async (payload, id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/admin/admin/permissions/${id}`,
    method: 'patch',
    payload: payload
  });
  if (status === constant.Success) {
    await getAdminUsers()
    return { status };
  }
  return { status, errorMessage };
};

const updateAdminUsers = async (payload, id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/admin/action-business-status?${id}`,
    method: 'patch',
    payload: payload
  });

  if (status === constant.Success) {
    return { status };
  }

  return { status, errorMessage };
};

const revokeAdminPermission = async (payload, id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/admin/revoke/permissions/${id}`,
    method: 'patch',
    payload: payload
  });

  if (status === constant.Success) {
    return { status };
  }

  return { status, errorMessage };
};

const getRoles = async () => {
  const { status, errorMessage, data } = await apiRequest({
    url: '/roles',
    method: 'get',
  });
  if (status === constant.Success) {
    const { roles } = data || {};
    adminStore.setRoles(roles)
    return { status }
  }
  return { status, errorMessage };
};

export default {
  revokeAdminPermission,
  setAdminPermissions,
  getPermissions,
  getAdminUsers,
  createAdminUsers,
  editAdminUsers,
  updateAdminUsers,
  getRoles,
}
